import { IUserPreferenceApiConnector } from '@/modules/api/UserPreferenceApiConnector/IUserPreferenceApiConnector';
import { API_TIMEOUTS } from '../constant';
import { BaseConnector } from '@/modules/api/BaseConnector';
import { getConfig } from '@/modules/common/helpers/config';
import { UserPreferenceName } from '@/modules/userPreferences';
import { UserPreferenceKeyValue } from '@/modules/userPreferences/types';

export class UserPreferenceApiConnector
  extends BaseConnector
  implements IUserPreferenceApiConnector
{
  private static instance: UserPreferenceApiConnector;
  private static baseUrl = getConfig().api.userPreferences.url;
  private static scopes = [getConfig().api.userPreferences.scope];

  public static getInstance(): IUserPreferenceApiConnector {
    if (!UserPreferenceApiConnector.instance) {
      UserPreferenceApiConnector.instance = new UserPreferenceApiConnector();
    }
    return UserPreferenceApiConnector.instance;
  }

  private constructor() {
    super(
      UserPreferenceApiConnector.baseUrl,
      UserPreferenceApiConnector.scopes,
      API_TIMEOUTS.userPreferences,
    );
  }

  async fetchAll(): Promise<UserPreferenceKeyValue[]> {
    return this.get<UserPreferenceKeyValue[]>('', {
      requiredErrorMessage: 'Failed to retrieve user preferences',
    });
  }

  async create(name: UserPreferenceName, value: unknown): Promise<boolean> {
    const result = await this.post<unknown>(`setting/${name}`, value, {
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    });

    return result !== undefined;
  }

  async update(name: UserPreferenceName, value: unknown): Promise<boolean> {
    const result = await this.put<unknown>(`setting/${name}`, value, {
      config: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    });

    return result !== undefined;
  }
}
